import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import type { WorkflowStep as TWorkflowStep } from "../types";
import { WorkflowInoculation } from "./workflow/WorkflowInoculation";
import { WorkflowResultEntry } from "./workflow/WorkflowResultEntry";

export function WorkflowStep({ step }: { step: TWorkflowStep }) {
  return (
    <>
      {step.components?.map((component) => {
        switch (component) {
          case "INOCULATION":
            return <WorkflowInoculation step={step} key={step.id} />;
          case "RESULT_ENTRY":
            return <WorkflowResultEntry step={step} key={step.id} />;
          default:
            return null;
        }
      })}
      {/* <BasicWorkflowStepComponent step={step} /> */}
      {/* {!step.template.components || step.template.components.length === 0 ? (
        <BasicWorkflowStepComponent step={step} />
      ) : null} */}
    </>
  );
}

export function WorkflowStepHeader({
  title,
  description,
  status,
}: {
  title: string;
  description?: string;
  status?: string | null;
}) {
  return (
    <div className="flex flex-col gap-1.5 px-6 py-4 border-b">
      <div className="flex gap-2 justify-between">
        <Heading level={2}>{title}</Heading>
        {/* {status && (
          <Badge
            variant="soft"
            color={status === "COMPLETED" ? "green" : "gray"}
          >
            {status === "COMPLETED" ? "Completed" : "Pending"}
          </Badge>
        )} */}
      </div>
      {description && (
        <Text size="sm" muted>
          {description}
        </Text>
      )}
    </div>
  );
}

// export function BasicWorkflowStepComponent({ step }: { step: TWorkflowStep }) {
//   const { workflow, testRun } = useWorkspace();
//   const submitExecution = trpc.runs.submitExecution.useMutation(
//     mutationResponse({
//       errorTitle: "Failed to submit execution",
//       successMessage: "Execution submitted",
//     }),
//   );
//   const methods = useForm();
//   const onSubmit = (data: any) => {
//     submitExecution.mutate({
//       workflowId: workflow.id,
//       workflowVersion: workflow.version,
//       stepId: step.id,
//       testRunId: testRun.id,
//       startedAt: data.startedAt,
//       metadata: data.metadata,
//     });
//   };
//   if (step.execution) {
//     return (
//       <>
//         {step.metadata && <WorkflowMetadata step={step} />}
//         {step.timeFields && <WorkflowTimeFields step={step} />}
//       </>
//     );
//   }
//   return (
//     <FormProvider {...methods}>
//       <form
//         onSubmit={methods.handleSubmit(onSubmit)}
//         className="px-6 py-4 space-y-4"
//       >
//         {step.metadata && <WorkflowMetadata step={step} />}
//         {step.timeFields && <WorkflowTimeFields step={step} />}
//         <Separator />
//         <Button type="submit" isPending={submitExecution.isPending}>
//           Submit
//         </Button>
//       </form>
//     </FormProvider>
//   );
// }
